(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-updated"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  document.addEventListener('DOMContentLoaded', () => {
    // Only target primary items that are inside a details > summary
    const primarySelector = 'details summary .main-nav__item--primary';
    const primaryEls = Array.from(document.querySelectorAll(primarySelector));
    if (!primaryEls.length) return;

    // Unique list of details that contain those primary items
    const detailsList = Array.from(new Set(primaryEls.map((p) => p.closest('details')).filter(Boolean)));

    // Init: sync classes & aria
    detailsList.forEach((d) => {
      const p = d.querySelector('.main-nav__item--primary');
      d.classList.toggle('is-open', !!d.open);
      if (p) p.setAttribute('aria-expanded', String(!!d.open));
    });

    function closeAllExcept(keep) {
      detailsList.forEach((d) => {
        if (d === keep) return;
        if (d.classList.contains('is-open') || d.open) {
          d.classList.remove('is-open');
          d.open = false;
          const p = d.querySelector('.main-nav__item--primary');
          if (p) p.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function toggleDetail(details, primEl) {
      const willOpen = !details.classList.contains('is-open');
      if (willOpen) {
        closeAllExcept(details);
        details.classList.add('is-open');
        details.open = true;
        if (primEl) primEl.setAttribute('aria-expanded', 'true');
      } else {
        details.classList.remove('is-open');
        details.open = false;
        if (primEl) primEl.setAttribute('aria-expanded', 'false');
      }
    }

    primaryEls.forEach((p) => {
      // Make focusable only if it's not already interactive
      const isInteractive = p.matches('a, button, [href], [tabindex]');
      if (!isInteractive) p.setAttribute('tabindex', '0');

      p.addEventListener('click', (e) => {
        // don't intercept clicks on links/buttons inside the primary item
        const interactiveChild = e.target.closest('a, button, input, select, textarea, label');
        if (interactiveChild && interactiveChild !== p) return;

        const details = p.closest('details');
        if (!details) return;

        e.preventDefault();
        e.stopPropagation();
        toggleDetail(details, p);
      });

      p.addEventListener('keydown', (e) => {
        const isEnter = e.key === 'Enter';
        const isSpace = e.key === ' ' || e.key === 'Spacebar' || e.code === 'Space';
        if (!(isEnter || isSpace)) return;

        // prevent page scroll on Space
        e.preventDefault();
        const details = p.closest('details');
        if (!details) return;
        toggleDetail(details, p);
      });
    });

    // Keep classes synced if <details> is toggled by other means (native summary click, script, etc.)
    detailsList.forEach((d) => {
      d.addEventListener('toggle', () => {
        const p = d.querySelector('.main-nav__item--primary');
        if (d.open) {
          closeAllExcept(d);
          d.classList.add('is-open');
          if (p) p.setAttribute('aria-expanded', 'true');
        } else {
          d.classList.remove('is-open');
          if (p) p.setAttribute('aria-expanded', 'false');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  if (!window.theme || !theme.mediaQueries) return;

  const isDesktop = () =>
    window.matchMedia(theme.mediaQueries.md).matches;

  function getTopLevelDetails(el) {
    const li = el.closest('li');
    const nav = li?.closest('ul.main-nav');
    if (!li || !nav) return null;
    return li.parentElement === nav ? li.querySelector(':scope > details') : null;
  }

  function closeSiblingMenus(details) {
    if (!details) return;

    const li = details.closest('li');
    const nav = li?.closest('ul.main-nav');
    const mainMenu = details.closest('main-menu');
    if (!nav) return;

    let closedAny = false;

    nav.querySelectorAll(':scope > li > details.is-open, :scope > li > details[open]')
      .forEach(d => {
        if (d === details) return;
        d.classList.remove('is-open');
        d.open = false;
        closedAny = true;
      });

    if (closedAny && mainMenu?.overlayOpen) {
      mainMenu.toggleOverlay(false);
      mainMenu.childNavOpen = false;
    }
  }

  /* ======================================================
     DESKTOP KEYBOARD (Enter / Space)
     ====================================================== */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (!isDesktop()) return;

    const toggle = e.target.closest('.js-toggle, .js-nav-hover');
    if (!toggle) return;

    const details = getTopLevelDetails(toggle);
    if (!details) return;

    e.preventDefault();
    e.stopPropagation();

    closeSiblingMenus(details);

    if (details.open || details.classList.contains('is-open')) return;

    toggle.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
  });

  /* ======================================================
     DESKTOP TAB / NVDA FOCUS
     ====================================================== */
  document.addEventListener('focusin', (e) => {
    if (!isDesktop()) return;

    const toggle = e.target.closest('.js-toggle, .js-nav-hover');
    if (!toggle) return;

    const details = getTopLevelDetails(toggle);
    if (!details) return;

    closeSiblingMenus(details);
  });

  /* ======================================================
     MOBILE: collapse internal details
     ====================================================== */
  function collapseInternalDetailsForMobile() {
    if (isDesktop()) return;

    document
      .querySelectorAll('.main-nav__child details[open]')
      .forEach(details => {
        details.dataset.mobileCollapsed = 'true';
        details.open = false;
        details.classList.remove('is-open');

        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      });
  }

  /* ======================================================
     DESKTOP: FORCE internal details OPEN (NO CLICK TOGGLE)
     ====================================================== */
  function forceInternalDetailsOpenOnDesktop() {
    if (!isDesktop()) return;

    document
      .querySelectorAll('.main-nav__child details')
      .forEach(details => {
        details.open = true;
        details.classList.remove('is-closing');
        delete details.dataset.mobileCollapsed;

        const summary = details.querySelector('summary');
        if (!summary) return;

        summary.setAttribute('aria-expanded', 'true');

        // 🔒 Prevent mouse click toggle ONLY
        summary.addEventListener('click', preventClickToggle, true);
      });
  }

  function preventClickToggle(e) {
    if (!isDesktop()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  /* ======================================================
     BREAKPOINT HANDLING
     ====================================================== */
  document.addEventListener('DOMContentLoaded', () => {
    collapseInternalDetailsForMobile();
    forceInternalDetailsOpenOnDesktop();
  });

  window.addEventListener('on:breakpoint-change', () => {
    collapseInternalDetailsForMobile();
    forceInternalDetailsOpenOnDesktop();
  });

})();



  } catch(e) { console.error(e); }
})();
})();
